import { defineMessages, IntlShape } from "react-intl";

import StorageProvider from "@mapmycustomers/shared/enum/resources/StorageProvider";

const messages = defineMessages<StorageProvider>({
  [StorageProvider.GOOGLE_DRIVE]: {
    id: "resources.connections.provider.googleDrive",
    defaultMessage: "Google Drive",
    description: "Google Drive provider label",
  },
  [StorageProvider.ONEDRIVE]: {
    id: "resources.connections.provider.oneDrive",
    defaultMessage: "OneDrive",
    description: "OneDrive provider label",
  },
  [StorageProvider.S3]: {
    id: "resources.connections.provider.amazonS3",
    defaultMessage: "Amazon S3",
    description: "S3 provider label",
  },
  [StorageProvider.SHAREPOINT]: {
    id: "resources.connections.provider.sharePoint",
    defaultMessage: "SharePoint",
    description: "SharePoint provider label",
  },
});

export const getProviderDisplayName = (intl: IntlShape, provider: StorageProvider) =>
  intl.formatMessage(messages[provider]);
